"use client"

import {
  ShieldCheck,
  CalendarCheck2,
  CalendarArrowDown,
  CalendarX2,
  CalendarOff,
  HelpCircle,
} from "lucide-react"
// Import do módulo PURO de badge. NÃO trocar por "@/lib/cancel-badge": lá
// importa "mongodb", e isso faz o webpack bundlar `net`/`tls`/`child_process`
// para o browser e derruba o build. Ver a nota de topo de lib/badge-copy.ts.
import { badgeCounts, shouldShowBadge, type BadgeLevel, type CancelBadgePayload } from "@/lib/badge-copy"

export { badgeCounts }

// green = 0% ("Nunca cancela caronas") tem ícone próprio: os 4 calendários
// cobriam as 4 faixas de taxa, e "nunca cancela" não é "raramente" — é melhor
// que isso.
const ICON_BY_LEVEL = {
  green: ShieldCheck,
  blue: CalendarCheck2,
  yellow: CalendarArrowDown,
  orange: CalendarX2,
  red: CalendarOff,
} as const

function Icon({ level }: { level: BadgeLevel | null }) {
  const Cmp = (level && ICON_BY_LEVEL[level]) || HelpCircle
  return <Cmp className="w-4 h-4 shrink-0" />
}

/** Linha da página da carona: ícone + frase + contador. */
export function CancelBadgeRow({ stat }: { stat: CancelBadgePayload | null | undefined }) {
  if (!shouldShowBadge(stat)) return null
  return (
    <div className="flex items-center gap-2">
      <span style={{ color: stat.color }}>
        <Icon level={stat.level} />
      </span>
      <p className="font-medium" style={{ color: stat.textColor }}>
        {stat.label}
        <span className="opacity-70"> · {badgeCounts(stat)}</span>
      </p>
    </div>
  )
}

/**
 * Pílula do perfil: ponto + frase + contador. `size` para diferenciar o card
 * do perfil público do cabeçalho do perfil próprio.
 *
 * A regra de quando NÃO renderizar vive em `shouldShowBadge`
 * (lib/badge-copy.ts) — não aqui dentro do JSX, para ter cobertura de teste.
 */
export function CancelBadgePill({
  stat,
  size = "sm",
}: {
  stat: CancelBadgePayload | null | undefined
  size?: "sm" | "md"
}) {
  if (!shouldShowBadge(stat)) return null
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 w-fit font-medium ${
        size === "md" ? "text-sm" : "text-xs"
      }`}
      style={{ color: stat.textColor, backgroundColor: `${stat.color}14` }}
    >
      <span className="h-2 w-2 rounded-full shrink-0" style={{ backgroundColor: stat.color }} />
      {stat.label}
      <span className="opacity-70"> · {badgeCounts(stat)}</span>
    </span>
  )
}
